/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ year: NonNullable<unknown>, brand: NonNullable<unknown> }} Public_Site_Footer_CopyrightInputs */

const cs_public_site_footer_copyright = /** @type {(inputs: Public_Site_Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} ${i?.brand}. Všechna práva vyhrazena.`)
};

const en_public_site_footer_copyright = /** @type {(inputs: Public_Site_Footer_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} ${i?.brand}. All rights reserved.`)
};

/**
* | output |
* | --- |
* | "© {year} {brand}. All rights reserved." |
*
* @param {Public_Site_Footer_CopyrightInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_footer_copyright = /** @type {((inputs: Public_Site_Footer_CopyrightInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Footer_CopyrightInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_footer_copyright(inputs)
	return cs_public_site_footer_copyright(inputs)
});